var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Divider, Typography, styled, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useRef, useState } from 'react';
import { MicrophoneIcon } from '../../../assets/customIcons';
import { AudioGif, DeleteButtonNewIcon } from '../../../assets/images';
import { AudioPlayer, MuiButton, MuiPopup, MuiStack } from '../../../components';
import { systemColor } from '../../../theme/systemColor';
import { convertBlobToWav, formatTime } from '../../../utils/utils';
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "60px",
        width: "60px"
    };
});
export default function AudioCaptureComponent(props) {
    var _this = this;
    var open = props.open, handleModelClick = props.handleModelClick, handleConfirmClick = props.handleConfirmClick;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var mediaRecorder = useRef(null);
    var _a = useState(false), isPlaying = _a[0], setIsPlaying = _a[1];
    var _b = useState([]), audioChunks = _b[0], setAudioChunks = _b[1];
    var _c = useState(0), audioDuration = _c[0], setAudioDuration = _c[1];
    var _d = useState(""), audioUrl = _d[0], setAudioUrl = _d[1];
    var _e = useState(null), stream = _e[0], setStream = _e[1];
    var _f = useState({
        audioBlobUrl: '',
        audioFile: '',
        audioDuration: 0
    }), audioUrlOnConfirm = _f[0], setAudioUrlOnConfirm = _f[1];
    useEffect(function () {
        var interval;
        if (isPlaying) {
            var startTime_1 = Date.now();
            interval = setInterval(function () {
                setAudioDuration(Math.floor((Date.now() - startTime_1) / 1000));
            }, 1000);
        }
        return function () {
            clearInterval(interval);
        };
    }, [isPlaying]);
    var startRecording = function () {
        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then(function (stream) {
            setStream(stream);
            mediaRecorder.current = new MediaRecorder(stream);
            if (stream) {
                setIsPlaying(true);
                var containers = ['webm', 'ogg', 'mp4', 'x-matroska', '3gpp', '3gpp2', '3gp2', 'quicktime', 'mpeg', 'aac', 'flac', 'wav'];
                var supportedAudios = containers.map(function (format) { return "audio/".concat(format); }).filter(function (item) { return MediaRecorder.isTypeSupported(item); });
                if (supportedAudios.length > 0) {
                    var media = new MediaRecorder(stream, {
                        mimeType: supportedAudios[0]
                    });
                    mediaRecorder.current = media;
                    mediaRecorder.current.start();
                    var localAudioChunks_1 = [];
                    mediaRecorder.current.ondataavailable = function (event) {
                        if (typeof event.data === "undefined")
                            return;
                        if (event.data.size === 0)
                            return;
                        localAudioChunks_1.push(event.data);
                    };
                    setAudioChunks(localAudioChunks_1);
                }
            }
        }).catch(console.error);
    };
    var stopRecording = function () {
        setIsPlaying(false);
        //stops the recording instance
        if (mediaRecorder && mediaRecorder.current && mediaRecorder.current.state === 'recording') {
            setIsPlaying(false);
            mediaRecorder.current.stop();
            mediaRecorder.current.onstop = function () { return __awaiter(_this, void 0, void 0, function () {
                var audioBlob, convertedBlob, audioUrl, blobUrl;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            audioBlob = new Blob(audioChunks, {
                                type: 'audio/mp4'
                            });
                            return [4 /*yield*/, convertBlobToWav(audioBlob)];
                        case 1:
                            convertedBlob = _a.sent();
                            audioUrl = URL.createObjectURL(audioBlob);
                            setAudioUrl(audioUrl);
                            blobUrl = URL.createObjectURL(convertedBlob);
                            // Fetch the Blob data
                            fetch(blobUrl).then(function (response) { return response.blob(); }).then(function (blob) {
                                // Create a new File object from the Blob
                                var mp3File = new File([blob], "audio-".concat(new Date().toISOString(), ".mp3"), {
                                    type: 'audio/mpeg'
                                });
                                setAudioUrlOnConfirm({
                                    audioBlobUrl: blobUrl,
                                    audioFile: mp3File,
                                    audioDuration: audioDuration
                                });
                            }).catch(function (error) { return console.error('Error fetching Blob:', error); });
                            setAudioChunks([]);
                            return [2 /*return*/];
                    }
                });
            }); };
        }
        ;
    };
    var handleConfirmClickOnAudio = function () {
        handleConfirmClick(audioUrlOnConfirm);
        handleModelClick(false);
        setAudioUrl(null);
        setAudioDuration(0);
    };
    var onDeleteRecording = function () {
        setAudioUrl(null);
        setAudioDuration(0);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: open,
        title: "Record Audio",
        variant: "h1",
        onClose: function () {
            handleModelClick(false);
            setIsPlaying(false);
            setAudioUrl(null);
            setAudioDuration(0);
        },
        closeIcon: true,
        containerStyle: {
            "&.MuiDialogContent-root": {
                padding: "0px",
                // width: 'calc(90vw)'
                width: lgMode ? '500px' : 'calc(90vw)'
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 3,
        direction: 'column',
        paddingX: 3,
        paddingBottom: 3
    }, audioUrl ? /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            height: "150px"
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        bgcolor: '#F4F7FA',
        style: {
            border: '1px solid #DEE4EB',
            borderRadius: "8px",
            padding: '5px 16px 5px 5px',
            alignItems: 'center',
            alignSelf: 'center'
        }
    }, /*#__PURE__*/ React.createElement(AudioPlayer, {
        src: audioUrl,
        isSlider: true,
        audioDuration: audioDuration
    }), /*#__PURE__*/ React.createElement("img", {
        src: DeleteButtonNewIcon,
        alt: "gallery-disable",
        style: {
            width: '36px',
            height: '36px',
            marginLeft: '10px'
        },
        onClick: onDeleteRecording
    }))) : !isPlaying ? /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            display: 'flex',
            alignSelf: 'center',
            height: '136px',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        bgcolor: '#FFF7F0',
        sx: {
            height: '60px ',
            width: '60px',
            borderRadius: '24px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ React.createElement(MicrophoneIcon, {
        sx: {
            color: systemColor.primary
        },
        onClick: startRecording
    }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            height: '150px',
            border: '1px solid #DEE4EB',
            borderRadius: "8px",
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        style: {
            flexGrow: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: '#1B1D21',
            alignSelf: 'center'
        }
    }, formatTime(audioDuration)), /*#__PURE__*/ React.createElement(Img, {
        src: AudioGif,
        alt: "audioplayicon",
        style: {
            width: '100%'
        }
    })))), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            height: '1px',
            bgcolor: '#DEE4EB',
            width: '100%'
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        gap: '24px'
    }, audioUrl ? /*#__PURE__*/ React.createElement(MuiButton, {
        name: "Confirm",
        size: "medium",
        fullWidth: true,
        variant: "contained",
        id: "confirmUpload",
        onClick: handleConfirmClickOnAudio
    }) : !isPlaying ? /*#__PURE__*/ React.createElement(MuiButton, {
        name: t('RECORD_AUDIO'),
        size: "medium",
        fullWidth: true,
        variant: "contained",
        id: "recordAudio",
        onClick: startRecording
    }) : /*#__PURE__*/ React.createElement(MuiButton, {
        name: "Stop",
        size: "medium",
        fullWidth: true,
        variant: "contained",
        id: "stopAudio",
        onClick: stopRecording
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "outlined",
        name: "Cancel",
        size: "medium",
        fullWidth: true,
        id: "cancelUpload",
        onClick: function () {
            handleModelClick(false);
            setIsPlaying(false);
            setAudioUrl(null);
            setAudioDuration(0);
        }
    })))));
}
